import './App.css';
import Wrapper from './component/Wrapper';





function App() {
  return (
    <div className="App">
      <h1> Calculator</h1>
      <Wrapper/>
    </div>
  );
}

export default App;
